import { useState } from 'react';

import { IconPlus } from '@iwoca/icons';
import { AlertBox, Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    getTrueLayerErrorDetail,
    isTrueLayerFailureReturn
} from '../../../../../../../iwRouter/LocationHelper';
import { BankSelectionBody } from '../../../../../../modals/BankSelectionModal/BankSelectionBody';
import { useBankSelectionFlow } from '../../../../../../modals/BankSelectionModal/useBankSelectionFlow';
import { useGetLinkedAccounts } from '../../../../../../modals/BankSelectionModal/useGetLinkedAccounts';
import { LinkedAccount } from '../../../../../../ui/linkedAccount/LinkedAccount';

export const BankSelection = () => {
    const [trueLayerError] = useState<'cancelled' | 'error' | null>(() => {
        if (isTrueLayerFailureReturn()) {
            return getTrueLayerErrorDetail() === 'access_denied'
                ? 'cancelled'
                : 'error';
        }
        return null;
    });

    const linkedAccounts = useGetLinkedAccounts();
    const [showBankGrid, setShowBankGrid] = useState(false);

    const flow = useBankSelectionFlow();

    const errorBanner = trueLayerError && (
        <AlertBox
            variant={trueLayerError === 'cancelled' ? 'cancel' : 'failure'}
        >
            {trueLayerError === 'cancelled' ? (
                <FormattedMessage
                    id="_.funding_requirements.link_open_banking.cancelled"
                    defaultMessage="<b>We didn’t get your permission.</b> Select your bank below to try again."
                    values={{
                        b: (text) => <span className="font-bold">{text}</span>
                    }}
                />
            ) : (
                <FormattedMessage
                    id="_.funding_requirements.link_open_banking.error"
                    defaultMessage="<b>Hmm, that didn't work.</b> Please try again."
                    values={{
                        b: (text) => <span className="font-bold">{text}</span>
                    }}
                />
            )}
        </AlertBox>
    );

    if (linkedAccounts.length > 0 && !showBankGrid) {
        return (
            <div className="space-y-l">
                {errorBanner}
                <div className="space-y-s">
                    {linkedAccounts.map((account) => (
                        <LinkedAccount
                            key={account.accountId}
                            account={account}
                        />
                    ))}
                </div>

                <Button
                    type="button"
                    variant="tertiary"
                    onClick={() => setShowBankGrid(true)}
                    className="px-0"
                    size="small"
                >
                    <FormattedMessage
                        id="_.funding_requirements.link_open_banking.link_another"
                        defaultMessage="Link an additional account"
                    />
                    <IconPlus className="size-[16px]" />
                </Button>
            </div>
        );
    }

    return (
        <div className="space-y-l">
            {errorBanner}
            <BankSelectionBody
                isBankEvidence
                step={flow.step}
                selectedBank={flow.selectedBank}
                selectBank={flow.selectBank}
                unselectBank={flow.unselectBank}
                onLinkAnother={flow.linkAnother}
                linkedAccounts={showBankGrid ? linkedAccounts : []}
                trackingSource="funding_requirements"
                isFundingRequirementsRedesign
            />
        </div>
    );
};
